import styled from 'styled-components';

export const Logo = styled.div`
  height: 50px;
  text-align: center;
  margin-bottom: 60px;
  margin-top: 40px;
`;

export const SubHeader = styled.div`
  height: 22px;
  color: #003D50;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  font-family: 'Graphik Medium', 'Graphik', sans-serif;
  padding-bottom: 20px;
`;